import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getFieldErrorMessage } from '@avalara/bat-apps-shared/lib/form-validation';
import { SelectInput, FieldErrorMessage } from '../../../components/styled/components/sign-up';
import { clearFieldForValidation } from '../../../store/shared-signup';
import { updateSignupForm } from '../../../lib/side-effects/signup-form';
import { isFieldVisitedAndInvalid } from '../../../lib/shared-signup';
const FormSelect = ({ fieldName, fieldValues, validateDuringInput, addPadding, }) => {
    var _a;
    const dispatch = useDispatch();
    const { sharedSignup } = useSelector((state) => state);
    const value = sharedSignup.signupForm[fieldName] || '';
    const fieldMissingOrInvalid = isFieldVisitedAndInvalid(sharedSignup, fieldName);
    const disabled = sharedSignup.disableForm || !!((_a = sharedSignup.readOnlyFields) === null || _a === void 0 ? void 0 : _a.includes(fieldName));
    const handleFormChange = (event) => {
        dispatch(updateSignupForm(fieldName, event.target.value));
    };
    const handleClearFieldValidation = () => {
        dispatch(clearFieldForValidation(fieldName));
    };
    const handleFocus = () => {
        if (validateDuringInput) {
            handleClearFieldValidation();
        }
    };
    const selectOption = (f) => (f.display != null ? f.display : f.value);
    return (React.createElement(React.Fragment, null,
        React.createElement(SelectInput, { disabled: disabled, name: fieldName, id: fieldName, "aria-label": fieldName, "data-ref": fieldName, onChange: handleFormChange, onBlur: handleClearFieldValidation, onFocus: handleFocus, value: value },
            React.createElement("option", { value: "", disabled: true }, "Select..."), fieldValues === null || fieldValues === void 0 ? void 0 :
            fieldValues.map(f => (React.createElement("option", { key: `selectOption-${f.value}`, value: f.value || f.display }, selectOption(f))))),
        fieldMissingOrInvalid && (React.createElement(FieldErrorMessage, { className: `field-error-message ${addPadding != null ? 'margin-all-none' : ''}` },
            React.createElement("p", null, getFieldErrorMessage(fieldName, value))))));
};
export default FormSelect;
